import { Flex, Space, Text } from '@mantine/core';
import { PageContainer, PageHeader } from '../../../shared_components';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const QrError = () => {
  const { t } = useTranslation(['payment', 'common']);
  return (
    <PageContainer darkMode>
      <PageHeader
        title={t('qr_error_title')}
        message={t('qr_error_message')}
        darkMode
      />
      <Flex direction={'row'} justify={'center'}>
        <div
          style={{
            borderRadius: '50%',
            border: '1px solid var(--mantine-color-otherGrey60-0)',
            padding: '28px',
            margin: '40px',
          }}
        >
          <div
            style={{
              boxSizing: 'content-box',
              height: '48px',
              borderRadius: '50%',
              border: '1px solid var(--mantine-color-otherGrey30-0)',
              padding: '28px',
            }}
          >
            <ReportGmailerrorredIcon sx={{ fontSize: 48 }} />
          </div>
        </div>
      </Flex>
      <Text variant="white">{t('qr_error_paragraph_1')}</Text>
      <Space h={'var(--mantine-spacing-lg)'} />
      <Text variant="white">
        {t('qr_error_paragraph_2')}{' '}
        <Link
          to={'/'}
          style={{
            color: 'var(--mantine-color-clinicalWhite-0)',
            textDecoration: 'underline',
          }}
        >
          {t('support_team')}
        </Link>
      </Text>
    </PageContainer>
  );
};
